const carouselData = [
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20magazine%20cover%20style%20with%20bold%20warm%20crimson%20red%20and%20deep%20black%20tones%2C%20abstract%20geometric%20shapes%2C%20cinematic%20atmosphere%2C%20luxurious%20dark%20texture%2C%20high-end%20editorial%20design&width=1200&height=600&seq=carousel-img-1&orientation=landscape',
    title: '2026娱乐圈半年鉴：最轰动的十件事',
    desc: '从顶流塌房到网红翻车，从综艺名场面到资本大洗牌，回顾这半年来最让人津津乐道的娱乐圈大事件。',
    tag: '重磅专题',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Editorial%20magazine%20layout%20with%20warm%20amber%20golden%20accent%20lighting%2C%20abstract%20elegant%20composition%2C%20mysterious%20cinematic%20mood%2C%20dark%20sophisticated%20background%2C%20luxurious%20texture&width=1200&height=600&seq=carousel-img-2&orientation=landscape',
    title: '网红圈生存实录：光鲜背后的残酷真相',
    desc: '深入探访MCN机构内部运作，揭秘网红从签约到解约的全流程，那些你不知道的行业黑幕一次性曝光。',
    tag: '深度调查',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20style%20with%20rich%20terracotta%20and%20bronze%20warm%20tones%2C%20abstract%20shapes%2C%20mysterious%20atmosphere%2C%20dark%20elegant%20background%2C%20magazine%20cover%20composition&width=1200&height=600&seq=carousel-img-3&orientation=landscape',
    title: '综艺节目潜规则：你看到的都是剧本',
    desc: '邀请前综艺节目编导独家爆料，揭开选秀投票、真人秀剪辑、明星人设打造的层层内幕，看完再也不想追综艺了。',
    tag: '独家爆料',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Artistic%20editorial%20photography%20with%20warm%20crimson%20and%20gold%20lighting%2C%20abstract%20geometric%20elements%2C%20mysterious%20elegant%20mood%2C%20dark%20luxurious%20background%2C%20magazine%20spread%20aesthetic&width=1200&height=600&seq=carousel-img-4&orientation=landscape',
    title: '粉丝经济泡沫：一个站姐的自白',
    desc: '从追星少女到职业站姐，她经历了什么？代拍产业链、私生饭乱象、粉丝集资黑洞，一个圈内人的真实讲述。',
    tag: '人物特写',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20magazine%20style%20with%20warm%20golden%20amber%20lighting%2C%20abstract%20shapes%2C%20mysterious%20elegant%20atmosphere%2C%20dark%20sophisticated%20background%2C%20editorial%20cover%20composition&width=1200&height=600&seq=carousel-img-5&orientation=landscape',
    title: '娱乐圈资本局：谁在操控你的注意力',
    desc: '盘点背后掌控娱乐圈的几大资本力量，从影视公司到互联网巨头，揭示热搜榜单、话题营销的运作逻辑。',
    tag: '产业分析',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
            焦点专题
          </h2>
          <p className="text-background-300/70 text-sm md:text-base max-w-lg mx-auto">
            深度策划的重磅专题，带你穿透八卦看见真相
          </p>
        </div>

        <div className="space-y-4 md:space-y-5">
          {carouselData.map((item, idx) => (
            <div
              key={idx}
              className="relative rounded-2xl overflow-hidden bg-background-900/50 group cursor-pointer"
            >
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-2/5 aspect-[16/7] lg:aspect-auto lg:min-h-[220px] relative overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-transparent lg:bg-gradient-to-r lg:from-black/50 lg:to-transparent"></div>
                </div>
                <div className="lg:w-3/5 p-6 md:p-8 flex flex-col justify-center">
                  <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 text-primary-300 text-xs font-medium mb-3 w-fit">
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 mb-2 group-hover:text-primary-300 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-background-300/70 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}